/**
 * Bootstrap JS
 * Implements service locator pattern
 * @type {Object}
 */

var modules = {}, forms = {}, translations = {}, services = {}, validators = {}, configs = {}, middleware = {};

// add assign polyfill
if (typeof Object.assign !== 'function') {
  Object.assign = function(target, varArgs) {
    if (target == null) { // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource != null) { // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}

/**
 * replace vars in the text with corresponding values
 * like 'Something {#XXX}' => 'Something YYY'
 * @param text
 * @param vars
 * @returns {*}
 */
var replaceVars = function(text, vars) {
  if (typeof vars === 'object' && vars && typeof text === 'string') {
    var regexp;
    for (var i in vars) {
      regexp = new RegExp('\{#'+ i +'\}', 'g');
      text = text.replace(regexp, vars[i]);
    }
  }
  return text;
};

// setup IE flag
window.isIE = (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0);

if (typeof String.prototype.replaceAll !== 'function') {
  String.prototype.replaceAll = function(search, replace){
    return this.split(search).join(replace);
  };
}

/**
 * base object
 * @type {{hash: {_events: {}, _dispatcher: null, _hash: null, set: webtBootstrap.hash.set, exists: webtBootstrap.hash.exists, get: webtBootstrap.hash.get, setEvent: webtBootstrap.hash.setEvent, parse: webtBootstrap.hash.parse, clear: webtBootstrap.hash.clear, dispatch: webtBootstrap.hash.dispatch}, _popup: Array, _popup_tout: Array, popup: webtBootstrap.popup, __loaders: Array, loader: webtBootstrap.loader, ___myWindow: null, window: webtBootstrap.window, __layer: null, layer: webtBootstrap.layer, cookie: {set: webtBootstrap.cookie.set, get: webtBootstrap.cookie.get, remove: webtBootstrap.cookie.remove}}}
 */
const webtBootstrap = {

  /**
   * registering configuration
   * @param name Namespace of the configuration
   * @param config Specified configuration
   */
  registerConfig: function (name, config) {
    if (typeof config === 'function') {
      configs[name] = config();
    } else {
      configs[name] = config;
    }
  },

  /**
   * check whether specified config registered
   * @param name
   * @returns {boolean|*}
   */
  isConfigExists: function (name) {
    if (typeof name === 'string' && name !== '') {
      return typeof configs[name] !== 'undefined' && configs[name];
    } else {
      throw new Error('Configuration namespace is not defined');
    }
  },

  /**
   * return specified configuration
   * @param name Namespace
   * @returns {*}
   */
  getConfig: function (name) {
    if (!this.isConfigExists(name)) {
      throw new Error('Cannot find configuration ' + name);
    }

    return configs[name];
  },

  /**
   * get specified language
   * @param message String, that can have '##' splitters
   * @param replaces Corresponding variables to replace values
   * @returns {*}
   */
  trans: function (message, replaces) {
    if (typeof message === 'string' && message !== '') {
      // splitting items to the levels
      var s = message.split('##');

      var tree = translations[webtBootstrap.getConfig('globalSettings').locale];

      for (var i = 0, l = s.length; i < l; i++) {
        if (typeof tree[s[i]] !== 'undefined') {
          tree = tree[s[i]];
        } else {
          return message;
        }
      }

      return typeof replaces === 'object' && replaces && typeof tree === 'string' ? replaceVars(tree, replaces) : tree;
    } else {
      throw new Error('Translations not set');
    }
  },

  /**
   * registering translations
   * @param trans Should be or object, or function
   */
  registerTranslations: function (trans) {
    let lang = webtBootstrap.getConfig('globalSettings').locale;
    if (typeof translations[lang] === 'undefined') {
      translations[lang] = {};
    }

    if (typeof trans === 'function') {
      translations[lang] = Object.assign({}, translations[lang], trans());
    } else {
      translations[lang] = Object.assign({}, translations[lang], trans);
    }
  },

  /**
   * register validator
   * @param validator
   * @param getter
   */
  registerValidator : function (validator, getter) {
    validators[validator] = getter;
  },

  /**
   * get specified validator
   * @param validator
   * @returns {*}
   */
  getValidator: function (validator) {
    if (typeof validator === 'string' && validator !== '') {
      if (typeof validators[validator] !== 'undefined' && validators[validator]) {
        return validators[validator];
      } else {
        throw new Error('Cannot find validator ' + validator);
      }
    } else {
      throw new Error('Validator name is not defined');
    }
  },

  /**
   * registering service
   * @param service
   * @param getter
   */
  registerService: function (service, getter) {
    if (typeof services[service] === 'undefined') {
      services[service] = getter;
    } else {

    }
  },

  /**
   * get specified service
   * @param service
   * @returns {*}
   */
  getService: function (service) {
    if (typeof service === 'string' && service !== '') {
      if (typeof services[service] === 'function') {
        return services[service]();
      } else {
        throw new Error('Cannot find service ' + service);
      }
    } else {
      throw new Error('Service name is not defined');
    }
  },

  /**
   * check if service already registered
   * @param service
   * @returns {boolean}
   */
  isServiceExists: function (service) {
    if (typeof service === 'string' && service !== '') {
      return typeof services[service] === 'function';
    } else {
      throw new Error('Service name is not defined');
    }
  },

  /**
   * register middleware
   * @param {String} namespace
   * @param {Function} handler
   */
  registerMiddleware: function (namespace, handler) {
    if (typeof middleware[namespace] === 'undefined' ) {
      middleware[namespace] = [];
    }
    middleware[namespace].push(handler);
  },

  /**
   * return all middleware for specified namespace
   * @param {String} namespace
   * @returns {Function[]}
   */
  getMiddleware: function (namespace) {
    if (typeof namespace === 'string') {
      if (typeof middleware[namespace] !== 'undefined') {
        return middleware[namespace];
      } else {
        return [];
      }
    } else {
      throw new Error('Service name is not defined');
    }
  },
};

export default Object.freeze(webtBootstrap);
export function __t (message, replace) { return webtBootstrap.trans(message, replace); };
